import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { LineModel } from '@data-layer/models/entry-summaries';
import { HTS_MASK } from '@helpers/custom-validator';
import { ValidationMessageModel } from '@data-layer/models/common';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import {
  enumDocumentRelatedEntityType,
  enumDocumentRootEntityType,
  enumDocumentState,
  enumDocumentType,
} from '@data-layer/enums/documents';
import { Observable } from 'rxjs';
import { IEsDocumentStateUpdate } from '../../interfaces';

@Component({
  selector: 'es-line-item-attach-document',
  templateUrl: './es-line-item-attach-document.component.html',
  styleUrls: ['./es-line-item-attach-document.component.scss'],
})
export class EsLineItemAttachDocumentComponent implements OnChanges {
  @Input() public entrySummaryId: number;
  @Input() public lineItem: LineModel;
  @Input() public attachedDocuments: DocumentModel[] = [];
  @Input() public isCanUploadDocuments: boolean = false;
  @Input() public isCanRemoveDocuments: boolean = false;
  @Input() public index: number;
  @Input() public isCanLoadOther: boolean = false;
  @Input() public isShowEmptyDocuments: boolean = true;
  @Input() public validationMessages: ValidationMessageModel[] = [];
  @Input() public upload: (document: DocumentCreateModel, file: File) => Observable<any>;
  @Input() public remove: (documentId: number) => Observable<any>;
  @Output() public addLineItemOtherDocument: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
  @Output() public stateUpdate: EventEmitter<IEsDocumentStateUpdate> = new EventEmitter<IEsDocumentStateUpdate>();

  public lineItemDoc: DocumentModel;
  public otherLineItemDocs: DocumentModel[] = [];
  public enumDocumentType: typeof enumDocumentType = enumDocumentType;
  public includesTypes: enumDocumentType[] = [enumDocumentType.PERMIT, enumDocumentType.TRADE_CERTIFICATE, enumDocumentType.UNKNOWN];
  public HTS_MASK: string = HTS_MASK;
  public createDocumentTemplate: DocumentCreateModel;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachedDocuments) {
      this.prepareLineItemDocuments();
    }
    this.createDocumentTemplate = {
      relatedEntityType: enumDocumentRelatedEntityType.LINE_ITEM,
      relatedEntityId: this.lineItem.id,
      rootEntityType: enumDocumentRootEntityType.ENTRY_SUMMARY,
      rootEntityId: this.entrySummaryId,
      fileName: null,
      type: null,
    };
  }

  public onStateUpdate(data: IEsDocumentStateUpdate) {
    this.stateUpdate.emit(data);
  }

  private prepareLineItemDocuments(): void {
    const lineItemDoc = this.findAttachedDocument() || {
      relatedEntityId: this.lineItem.id,
      type: enumDocumentType.UNKNOWN,
      relatedEntityType: enumDocumentRelatedEntityType.LINE_ITEM,
      rootEntityType: enumDocumentRootEntityType.ENTRY_SUMMARY,
      rootEntityId: this.entrySummaryId,
      createdDate: null,
      url: null,
      fileName: null,
      id: null,
      state: enumDocumentState.CREATED,
    };

    this.lineItemDoc = this.mergeDocument(this.lineItemDoc, lineItemDoc);

    this.otherLineItemDocs = this.attachedDocuments.filter(
      (document) =>
        document.relatedEntityType === enumDocumentRelatedEntityType.LINE_ITEM &&
        document.relatedEntityId === this.lineItem.id &&
        document.id !== this.lineItemDoc.id,
    );
  }

  private findAttachedDocument() {
    return this.attachedDocuments.find(
      (document) =>
        document.relatedEntityType === enumDocumentRelatedEntityType.LINE_ITEM &&
        document.type === enumDocumentType.UNKNOWN &&
        document.relatedEntityId === this.lineItem.id,
    );
  }

  private mergeDocument(existedDocument: DocumentModel, newDocument: DocumentModel): DocumentModel {
    if (!existedDocument) {
      return newDocument;
    }
    Object.assign(existedDocument, newDocument);
    return existedDocument;
  }
}
